import { Box, keyframes } from '@mui/material';
import {
  discountBurstSrc,
  discountTenOffSrc,
  rapcoinRewardRibbonSrc,
  rapgemRewardRibbonSrc,
  vipRoomRewardRibbonSrc,
} from '../../assets/bazzar';

const discountBadgeBounce = keyframes`
  0%, 100% {
    transform: translateX(-50%) translateY(0) scale(1);
  }
  18% {
    transform: translateX(-50%) translateY(-14px) scale(1.08);
  }
  36% {
    transform: translateX(-50%) translateY(0) scale(0.96);
  }
  52% {
    transform: translateX(-50%) translateY(-7px) scale(1.04);
  }
  68% {
    transform: translateX(-50%) translateY(0) scale(0.99);
  }
  82% {
    transform: translateX(-50%) translateY(-3px) scale(1.01);
  }
`;

function DiscountBurst() {
  return (
    <Box
      sx={{
        position: 'absolute',
        left: '50%',
        top: { xs: 28, md: 28 },
        width: { xs: 173, md: 173 },
        height: { xs: 173, md: 173 },
        zIndex: 4,
        animation: `${discountBadgeBounce} 2.4s ease-in-out infinite`,
        transformOrigin: 'center center',
        willChange: 'transform',
      }}
    >
      <Box
        component="img"
        src={discountBurstSrc}
        alt="discount burst"
        sx={{
          display: 'block',
          width: '100%',
          height: '100%',
        }}
      />
      <Box
        component="img"
        src={discountTenOffSrc}
        alt="10% off"
        sx={{
          position: 'absolute',
          left: '50%',
          top: 80,
          transform: 'translate(-50%, -50%)',
          width: { xs: 75, md: 75 },
          height: { xs: 72, md: 72 },
          zIndex: 1,
        }}
      />
    </Box>
  );
}

const badgeShellSx = {
  position: 'relative',
  width: { xs: '100%', md: '100%' },
  maxWidth: 400,
  height: { xs: 228, md: 228 },
  mx: 'auto',
  my: { xs: 0, md: 2.2 },
};

const rewardRibbonSx = {
  position: 'absolute',
  left: '50%',
  top: { xs: 142, md: 142 },
  transform: 'translateX(-50%)',
  width: { xs: '100%', md: 400 },
  maxWidth: 400,
  height: 'auto',
  zIndex: 4,
};

function VipRoomDiscountBadge() {
  return (
    <Box sx={badgeShellSx}>
      <DiscountBurst />
      <Box component="img" src={vipRoomRewardRibbonSrc} alt="On All VIP Room" sx={rewardRibbonSx} />
    </Box>
  );
}

function RapGemDiscountBadge() {
  return (
    <Box sx={badgeShellSx}>
      <DiscountBurst />
      <Box component="img" src={rapgemRewardRibbonSrc} alt="On All RapGem" sx={rewardRibbonSx} />
    </Box>
  );
}

function RapCoinDiscountBadge() {
  return (
    <Box sx={badgeShellSx}>
      <DiscountBurst />
      <Box component="img" src={rapcoinRewardRibbonSrc} alt="On All RapCoin" sx={rewardRibbonSx} />
    </Box>
  );
}

export default function DiscountBadge({ storeTab }) {
  if (storeTab === 'vip-room') {
    return <VipRoomDiscountBadge />;
  }

  if (storeTab === 'rapgem') {
    return <RapGemDiscountBadge />;
  }

  return <RapCoinDiscountBadge />;
}
